import { isNil, negate } from 'lodash-es';

export const isNonNil = <T>(value: T | null | undefined): value is T => {
  return negate(isNil)(value);
};

export const cleanNilProps = <T extends Record<string, any>>(obj: T): T => {
  const result: Partial<T> = {};

  if (typeof obj !== 'object' || obj === null) {
    throw new Error('Input must be a non-null object.');
  }

  Object.keys(obj).forEach((key: keyof T) => {
    const value = obj[key];

    if (isNil(value)) {
      return;
    } else if (typeof value === 'object' && isNonNil(value)) {
      const cleanedValue = cleanNilProps(value);

      if (Object.keys(cleanedValue).length > 0) {
        result[key] = cleanedValue;
      }
    } else {
      result[key] = value;
    }
  });

  return result as T;
};

export const keys = <T extends Record<string, unknown>>(obj: T) =>
  Object.keys(obj) as Array<keyof T>;

export const mapKeys = <T extends Record<string, unknown>, R>(
  obj: T,
  fn: (key: keyof T) => R
) => {
  return keys(obj).map(fn);
};

export const toSpliced = <T>(
  array: T[],
  startIndex: number,
  count: number,
  ...values: T[]
) => {
  return [
    ...array.slice(0, startIndex),
    ...values,
    ...array.slice(startIndex + count),
  ];
};
